module.exports = __webpack_public_path__ + "static/media/add.824dcda1.svg";